import { NavigateFunction } from 'react-router-dom'

import { Delete, Pencil, Split } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

export type CategoryItem = {
  id: string
  name: string
}

type Options<T extends CategoryItem> = {
  item: T
  navigate: NavigateFunction
  onEdit: (item: T) => void
  onDelete: (item: T) => void
  showWorkflowAction?: boolean
  workflowPath?: (categoryId: string) => string
}

export const defaultWorkflowPath = (categoryId: string) => `${categoryId}/workflow`

export const buildCategoryItemActions = <T extends CategoryItem>({
  item,
  navigate,
  onEdit,
  onDelete,
  showWorkflowAction = false,
  workflowPath = defaultWorkflowPath,
}: Options<T>) => [
  ...(showWorkflowAction
    ? [
        {
          label: i18n.t('ticketing.workflows.configure_workflow_action'),
          icon: Split,
          onClick: () => navigate(workflowPath(item.id)),
        },
      ]
    : []),
  {
    label: i18n.t('common.edit'),
    icon: Pencil,
    onClick: () => onEdit(item),
  },
  {
    label: i18n.t('common.destroy'),
    icon: Delete,
    onClick: () => onDelete(item),
    critical: true,
  },
]
